import authDao from '../../../dao/authDao';
import {push} from 'react-router-redux';
import {
  changeLanguage,
  setAccountSummary,
} from '../../../components/auth/reducers';

const RESET = 'pages/auth/signin/RESET';
const SIGN_IN = 'pages/auth/signin/SIGN_IN';
const SIGN_IN_SUCCESS = 'pages/auth/signin/SIGN_IN_SUCCESS';
const SIGN_IN_FAIL = 'pages/auth/signin/SIGN_IN_FAIL';

const initialState = {
  error: '',
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case SIGN_IN:
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        error: '',
      };
    case SIGN_IN_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export function reset() {
  return {type: RESET};
}

export function signIn(email, password) {
  return dispatch => {
    dispatch({type: SIGN_IN});

    return authDao
      .signIn(email, password)
      .then(json => dispatch(signInSuccess(json)))
      .catch(error => dispatch(signInFail(error)));
  };
}

function signInSuccess(accountSummary) {
  return (dispatch, getState) => {
    dispatch({type: SIGN_IN_SUCCESS});
    dispatch(setAccountSummary(accountSummary));
    dispatch(changeLanguage(accountSummary.account.languageType));

    const from = getState().router.location;
    let to = {pathname: '/'};
    if (from && from.state && from.state.from) {
      const {pathname, search} = from.state.from;
      to = {pathname, search};
    }

    dispatch(push(to));
    return accountSummary;
  };
}

function signInFail(error) {
  return dispatch => {
    dispatch({
      type: SIGN_IN_FAIL,
      error: error,
    });
    return Promise.reject(error);
  };
}
